import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import RequestService from './services/request';

// RequestService initialization
RequestService.init(process.env.VUE_APP_SPOTIFY_API, store);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
